import eventbus from '@/eventbus.js'
import { objectIsEmpty } from '@/utils.js'
import { singularize } from '@/schema.js'

function normalizeUpdatePayload(store, payload) {
  if (!payload || objectIsEmpty(payload)) return

  Object.keys(payload).forEach(entityName => {
    const key = singularize(entityName)
    if (!store.state[key]) {
      eventbus.emit(`update:${key}`, payload[entityName])
      delete payload[entityName]
    }
  })

  if (!objectIsEmpty(payload)) {
    store.handleUpdate(payload)
  }
}

export default {
  channels: {
    ControlChannel: {
      connected() {
        this.sharedStore.setChannelConnected('control', true)
      },

      disconnected() {
        this.sharedStore.setChannelConnected('control', false)
      },

      received(data) {
        if (!data) return
        if (typeof data === 'string') data = JSON.parse(data)

        if (data.update) {
          normalizeUpdatePayload(this.sharedStore, data.update)
          return
        }

        if (data.create) {
          normalizeUpdatePayload(this.sharedStore, data.create)
          return
        }

        const msgType = data.msgType || data.msg_type
        if (msgType === 'reload') {
          window.location.reload(false)
          return
        }

        if (msgType === 'lps_monitor' && data.status) {
          this.sharedStore.state.lpsMonitorState = data.status
          return
        }

        if (msgType) {
          console.warn("Unhandled cable message type '%s'", msgType, data)
        }
      },
    },
  },
}
